import React, { useState, useEffect, useContext } from 'react'
import Add from '../Icons/Add'
import Decrease from '../Icons/Decrease'
import YyFood from '../Icons/YyFood'
import MyModal from '../myComponents/MyModal/MyModal'
import MyMenuModal from '../myComponents/MyMenuModal/MyModal'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { LanguageContext } from '../../contexts/LanguageContext'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import intl from 'react-intl-universal'
import {
  getAllYyFoodList,
  getAllXgFoodList,
  getFirstXgType,
  getFirstYyType,
  updateFoodNumByCache,
  foodDecrease,
  foodIncrease,
  foodTestForMax,
  addFoodTestForMax,
  updateYyTypeShow,
  updateXgTypeShow,
  updateYyTypeMarkNum,
  updateXgTypeMarkNum,
  readFromCacheInOrderPage
} from './OrderFunction'
import {
  OrderMiddle,
  OrderTabsTop,
  OrderTabsBottom,
  OrderTabsBottomFirst,
  OrderTabsBottomSecond
} from './OrderStyle.js'
import OrderContentDetails from './OrderContentDetails'

export default function OrderTabs (props) {
  const OrderInfo = useContext(OrderInfoContext)
  const OrderMark = useContext(OrderMarkContext)
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext)
  const Language = useContext(LanguageContext)
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [showMenuModal, setShowMenuModal] = useState(false) // 菜谱详情是否详情弹窗
  const [modalTitle, setModalTitle] = useState('') // 提示信息弹窗的标题
  const [modalOkButton, setModalOkButton] = useState('') // 提示信息的关闭按钮
  const [showCancel, setShowCancel] = useState(false)
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [flag, setFlag] = useState('') // 根据flag决定点击确定做什么操作

  //const [tabActive, setTabActive] = useState(0) // 第一层选项卡默认选中第一个
  const [tabActive, setTabActive] = useState(() => {
    const source = sessionStorage.getItem('order_source')
    sessionStorage.removeItem('order_source')
    const result =source === 'B' ? 1 : 0
    console.log('我是最后的数据', result) 
    return result
  })
  const [yyActive, setYyActive] = useState('') // 营养套餐的左侧列表，默认不选中任何条目
  const [xgActive, setXgActive] = useState('') // 小锅菜系的左侧列表，默认不选中任何条目
  const [yyFoodlist, setYyFoodlist] = useState([]) // 营养餐根据日期餐次获取的所有食物列表
  const [showYyFoodlist, setShowYyFoodlist] = useState([])// 营养套餐筛选后用于展示的食物列表
  const [xgFoodlist, setXgFoodlist] = useState([]) // 小锅菜系可以点的食物列表
  const [showXgFoodlist, setShowXgFoodlist] = useState([])// 小锅菜系筛选后用于展示的食物列表
  const [itemDataCopy, setItemDataCopy] = useState()// 存储用于展示的菜品的信息
  const sdxBg = require('../../images/sdxBg.png')
  const [isShowAdvice, setIsShowAdvice] = useState(false)// 菜单详情窗口
  const [yyFoodShowArr, setYyFoodShowArr] = useState({}) // 营养餐类型是否显示对象
  const [xgFoodShowArr, setXgFoodShowArr] = useState({}) // 营养餐类型是否显示对象
  const [yyFoodTypeMarkObj, setYyFoodTypeMarkObj] = useState({}) // 食物类型的份数对象
  const [xgFoodTypeMarkObj, setXgFoodTypeMarkObj] = useState({}) // 食物类型的份数对象
  const OrderShoppingHeight = (window.innerHeight - 50) * 0.07 < 48 ? (window.innerHeight - 50) * 0.07 : 48
  const [showLogo, setShowLogo] = useState(false)
  //新增：当进入点餐页面时候，默认选中第一个菜谱类别
  useEffect(() => {
    // setXgActive('all')
    if(xgFoodlist === showXgFoodlist && xgActive!=='all'){
      getFirstXgType(xgFoodShowArr, OrderMark.xgFoodType, xgFoodlist, setXgActive, setShowXgFoodlist)
    }
    if(yyFoodlist === showYyFoodlist && yyActive!=='all'){
      getFirstYyType (yyFoodShowArr, OrderMark.yyFoodType, yyFoodlist, setYyActive, setShowYyFoodlist)
    }
  // eslint-disable-next-line
  })

  useEffect(() => {
    if (HospitalBasicInfo.hospitalBasicInfo && HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
      setShowLogo(HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.showLogo)
    }
  }, [HospitalBasicInfo])

  // 餐次或者日期改变重新获取营养餐和小锅菜列表、更新左侧的菜谱类型的mark数字
  useEffect(() => {
    // setYyActive('all')
    // setXgActive('all')
    setYyFoodlist([])
    setShowYyFoodlist([])
    setXgFoodlist([])
    setShowXgFoodlist([])
    setFlag('')
    console.log('props.mealType, props.chooseDate, tabActive', props.mealType, props.chooseDate, tabActive)
    if (props.mealType !== '' && props.chooseDate !== '') {
      if (OrderInfo.isOrderInfoEmpty === true) { // 当缓存没有数据的时候 ，读取一次缓存，然后同步到页面上
        readFromCacheInOrderPage(OrderInfo, OrderMark, Language, xgFoodShowArr, yyFoodShowArr,setShowModal, setModalInfo, props, setYyFoodlist, setShowYyFoodlist, setXgFoodlist, setShowXgFoodlist, setShowCancel, setFlag, tabActive, setYyFoodTypeMarkObj, setXgFoodTypeMarkObj, setYyFoodShowArr, setXgFoodShowArr, setXgActive, setYyActive)
      } else {
        if (tabActive === 0) {
          getAllYyFoodList(props, OrderInfo, OrderMark, Language, yyFoodShowArr, setYyFoodlist, setShowYyFoodlist, setShowModal, setModalInfo, setShowCancel, setFlag, setYyFoodTypeMarkObj, setYyFoodShowArr, setYyActive)
        } else {
          getAllXgFoodList(props, OrderInfo, OrderMark, Language, xgFoodShowArr, setXgFoodlist, setShowXgFoodlist, setShowModal, setModalInfo, setFlag, setXgFoodTypeMarkObj, setXgFoodShowArr,setXgActive)
        }
      }
    }
  // eslint-disable-next-line
  }, [props.mealType, props.chooseDate, tabActive])
  // 如果前端缓存食物改变，将useContext中的食物数量同步到页面 + 更新左侧的菜谱类型的mark数字
  useEffect(() => {
    updateFoodNumByCache(OrderInfo, yyFoodlist, setYyFoodlist, showYyFoodlist, setShowYyFoodlist, xgFoodlist, setXgFoodlist, showXgFoodlist, setShowXgFoodlist)
  // eslint-disable-next-line
  }, [OrderInfo.cacheAllFoodList])
  useEffect(() => {
    updateYyTypeMarkNum(OrderMark, OrderInfo, props, setYyFoodTypeMarkObj)// 更新该营养餐类型已经点的份数
    updateXgTypeMarkNum(OrderMark, OrderInfo, props, setXgFoodTypeMarkObj)// 更新该小锅菜类型已经点的份数
  // eslint-disable-next-line
  }, [OrderInfo.cacheAllFoodList, OrderMark.yyFoodType, OrderMark.xgFoodType])
  useEffect(() => {
    updateYyTypeShow(OrderMark, yyFoodlist, setYyFoodShowArr) // 只显示有食物的营养餐类型
  // eslint-disable-next-line
  }, [OrderMark.yyFoodType])
  useEffect(() => {
    updateXgTypeShow(OrderMark, xgFoodlist, setXgFoodShowArr) // 只显示有食物的小锅菜类型
  // eslint-disable-next-line
  }, [OrderMark.xgFoodType])
  const firstTabs = [
    { title: 'Meal package' },
    { title: 'SmallPotDishes' }
  ]
  console.log('cessssStart')
  console.log('YYFoodlist',yyFoodlist)
  console.log('showYYFoodlist4',showYyFoodlist)
  console.log('props.mealType',props.mealType)
  console.log('props.chooseDate',props.chooseDate)
  console.log('tabActive',tabActive)
  console.log('yyFoodShowArr',yyFoodShowArr)
  console.log('yyActive',yyActive)
  console.log('cessssEnd')
  
  // 点击营养餐->全部营养餐食物。点击营养餐食物类型->该食物类型
  useEffect(() => {
    if (yyActive !== 'all') {
      setShowYyFoodlist(yyFoodlist.filter(item => {
        // console.log(item)
        return item.type_ID === yyActive
      }))
    } else {
      setShowYyFoodlist(yyFoodlist)
    }
  // eslint-disable-next-line
  }, [yyActive])
  // 点击小锅菜->全部小锅菜食物。点击小锅菜食物类型->该食物类型
  useEffect(() => {
    if (xgActive !== 'all') {
      setShowXgFoodlist(xgFoodlist.filter(item => {
        return item.food && item.food.type_ID === xgActive
      }))
    } else {
      setShowXgFoodlist(xgFoodlist)
    }
  // eslint-disable-next-line
  }, [xgActive])

  return (
    <OrderMiddle>
      {/* 第一级tabs */}
      <OrderTabsTop className='bgf h9 flex rel zx4'>
        {
          firstTabs.map((items, index) => {
            return (
              <li
                key={index}
                // className={'f1 tc h100 rel' + (tabActive === 0 && index === 0 ? ' fw5 boxShadowLeft' : tabActive === 1 && index === 1 ? ' fw5 boxShadowRight' : ' g6')}
                className={'f1 tc h100 rel' + (tabActive === index ? ' fw5' : ' g6')}
                onClick={() => {
                  if (tabActive !== index) {
                    if (index === 1) {
                      setShowModal(true)
                      setShowCancel(true)
                      setModalInfo(intl.get("Chef's special is designated for regular diet or pt's family."))
                      setFlag('tabCheck')
                    } else {
                      setTabActive(index)
                    }
                  }
                }}
              >{/* 点击营养套餐，切换到营养套餐，点击小锅菜则跳转到小锅菜 */}
                <div className={'h100 w100 flex-center fs15 tc' + (Language.locale === 'en' ? '' : ' lt1-5')} style={{ borderBottom: '0.5px solid #dcdedd' }}>
                  <div className='rel'>
                    {index === 0 ? <div className='abs b-3 l-29'><YyFood height={18} width={18} /></div> : ''}
                    {intl.get(items.title)}
                  </div>
                </div>
                { tabActive === index ? <div className={'bg01d7a1 b0 abs h12' + (index === 0 ? ' w50 l18p' : ' w42 l29p')} /> : '' }
              </li>
            )
          })
        }
        <div className='h70 w1px abs bd gdcdedd' style={{ left: '50%', borderWidth: '0.5px' }} />
      </OrderTabsTop>
      <div className='h1' />
      <OrderTabsBottom className='h90'>
        {/* 第2级第一个选项卡 */}
        <OrderTabsBottomFirst className={'h100 flex' + (tabActive === 0 ? '' : ' clip')}>
          {/* 第1.1级tabs的左侧内容(营养餐菜谱分类) */}
          <div className='h100 w20 rel'>
            <ul className='abs trbl0 rows bgf6 g0 fs12-4' style={{ bottom: `${OrderShoppingHeight}px` }}>
              {/* <li
                key={'checkAllYyFood'}
                className={'tc vc h11 rel' + (yyActive === 'all' ? ' bgf  w99 act' : '')}
                style={{ maxHeight: '45px' }}
                onClick={() => setYyActive('all')}
              >
                <div className='h100 rel'>
                  <div className='abs markNum pt1 fs10 gf h12r w14r' style={{ visibility: Number(OrderMark.allYyFoodMark) > 0 ? 'visible' : 'hidden' }}>
                    <div className='w14r tc ml-2'>
                      <div style={{ transform: 'scale(0.75)' }}>{OrderMark.allYyFoodMark}</div>
                    </div>
                  </div>
                </div>
                <div className='no-wrap tl ml10 mr5 lt1'>{intl.get('All')}</div>
              </li> */}
              {
                OrderMark.yyFoodType.map(yyItems => {
                  // console.log(yyItems)
                  if (yyFoodShowArr[`yyTypeShow${yyItems.id}`]) {
                    return (
                      <li
                        key={yyItems.id}
                        className={'tc vc h11 lh1-3 rel' + (yyActive === yyItems.id ? ' bgf w99 act' : '')}
                        style={{ maxHeight: '45px' }}
                        onClick={() => setYyActive(yyItems.id)}
                      >
                        <div className='h100 rel'>
                          <div className='abs markNum pt1 fs10 gf h12r w14r' style={{ visibility: yyFoodTypeMarkObj[`yyTpyeMark${yyItems.id}`] > 0 ? 'visible' : 'hidden' }}>
                            <div className='w14r tc ml-2'>
                              <div style={{ transform: 'scale(0.75)' }}>{yyFoodTypeMarkObj[`yyTpyeMark${yyItems.id}`]}</div>
                            </div>
                          </div>
                        </div>
                        <div className={'tl lt1 ml10 mr5' + (yyActive === yyItems.id ? '' : ' no-wrap')}>{yyItems.typeName}</div>
                      </li>
                    )
                  }
                })
              }
              <li
                key={'checkAllYyFood'}
                className={'tc vc h11 rel' + (yyActive === 'all' ? ' bgf  w99 act' : '')}
                style={{ maxHeight: '45px' }}
                onClick={() => setYyActive('all')}
              >
                <div className='h100 rel'>
                  <div className='abs markNum pt1 fs10 gf h12r w14r' style={{ visibility: Number(OrderMark.allYyFoodMark) > 0 ? 'visible' : 'hidden' }}>
                    <div className='w14r tc ml-2'>
                      <div style={{ transform: 'scale(0.75)' }}>{OrderMark.allYyFoodMark}</div>
                    </div>
                  </div>
                </div>
                <div className='no-wrap tl ml10 mr5 lt1'>{intl.get('All')}</div>
              </li>
            </ul>
          </div>
          {/* 第1.2级tabs的右侧内容(营养餐菜谱展示) */}
          <ul className={'h100 w80 rel flex-top pl9 pr9 pt3 ova'} style={showLogo ? { backgroundImage: `url(${sdxBg})`, backgroundSize: '120% 170%' } : { background: '#fff' }}>
            {
              flag.includes('getAllYyFood') && <li className='abs trbl0'>
                {
                  flag === 'getAllYyFood_1001' || flag === 'getAllYyFood_1004' ? <img alt='' className='w62 h35 abs auto l0 r0' style={{ top: '13%' }} src={require('../../images/specialFood.png')} />
                    : ['getAllYyFood_verifyOrderError_pad', 'getAllYyFood_verifyOrderError_PFS'].includes(flag) ? <img alt='' className='w62 h35 abs auto l0 r0' style={{ top: '13%' }} src={require('../../images/yycOrdered.png')} />
                      : <img alt='' className='w62 h35 abs auto l0 r0' style={{ top: '13%' }} src={require('../../images/noOrderImg.jpg')} />
                }
                <div className='abs h21r w100' style={{ bottom: '44%' }}>
                  <div className='tc auto w80 g7c fs13 lt1' style={{ height: '1.5rem' }}>
                    {
                      flag === 'getAllYyFood_1001' && intl.get("According to your dietician's advice, meal package will be Prepared by nutritionist")
                    }
                    {
                      flag === 'getAllYyFood_1002' && intl.get("Dietary advice is fasting, Patient can't order")
                    }
                    {
                      flag === 'getAllYyFood_1003' && intl.get('This meal has been ordered')
                    }
                    {
                      flag === 'getAllYyFood_1004' && intl.get('Please contact your dietician for food preparation')
                    }
                    {
                      flag === 'getAllYyFood_1005' && intl.get("The dietician's advice is to take care of themselves, and the patient can't order food")
                    }
                    {
                      flag === 'getAllYyFood_noFood' && intl.get('According to your dietary advice, this meal is not available')
                    }
                    {
                      flag === 'getAllYyFood_verifyOrderError_pad' && intl.get('orderedOnPad')
                    }
                    {
                      flag === 'getAllYyFood_verifyOrderError_PFS' && intl.get('orderedOnPFS')
                    }
                  </div>
                </div>
              </li>
            }
            {
              showYyFoodlist.length > 0 && showYyFoodlist.map(itemData => {
                // console.log(itemData)
                return (
                  <li key={itemData.checkId} className='w48 h27 rds8 ovh mb15 foodListBox bgf' style={{ maxHeight: '114px', minHeight: '100px' }}>
                    <div className='h67 ovh rel' onClick={() => { setIsShowAdvice(true); setItemDataCopy(itemData) }}>
                      {
                        itemData.picAddress && itemData.picAddress.indexOf('sodexo') >= 0
                          ? <img className='w100 h100' alt={intl.get('No pictures')} src={itemData.picAddress} />
                          : <div className='h100 bgf1 vc'>
                            <div className={'tc w100 fs23 ga5' + (Language.locale === 'en' ? '' : ' lt1-5')}>{intl.get('No pictures')}</div>
                          </div>
                      }
                    </div>
                    <div className='h33 pl5 pt2 pr5 fs12 rel'>
                      <div className='h50 rel fs11-5 no-wrap'>{itemData.foodName}</div>
                      <div className='h50 b rel priceColor'>
                        <div className='abs b5 fs11-5'>&yen;{itemData.unitPrice===0?' --':' '+ itemData.unitPrice}</div>
                      </div>
                      {// 如果后台营养餐已经达到最大份数，则只显示售罄
                        foodTestForMax(itemData)
                          ? <div>
                            <div className='abs w40 tr fs10 g6 r30 b5'>{intl.get('Sold out')}</div>
                            <div className={'abs r5 b2'}
                              style={{ bottom: '-0.06rem' }}
                              onClick={() => {
                                foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, props.chooseDate, OrderMark)
                              }}>
                              <Add />
                            </div>
                          </div>
                          : <div>
                            <div
                              className={'abs b2' + (itemData.selectedQuantity <= 0 ? ' disabled' : '')}
                              style={{ right: '3rem', bottom: '-0.06rem' }}
                              onClick={() => {
                                foodDecrease(itemData, OrderInfo)
                              }}>
                              {
                                itemData.selectedQuantity === 0 ? <Decrease /> : <Decrease circleBg={'#f31c69'} />
                              }
                            </div>
                            <div className='abs r20 b5 tc w21r fs11-5' style={{ bottom: '0.3rem' }}>{itemData.selectedQuantity ? itemData.selectedQuantity : 0 }</div>
                            <div
                              className={'abs r5 b2'}
                              style={{ bottom: '-0.06rem' }}
                              onClick={() => {
                                foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, props.chooseDate, OrderMark)
                              }}>
                              {
                                addFoodTestForMax(itemData, OrderInfo, props.chooseDate) ? <Add /> : <Add circleBg={'#f31c69'} />
                              }
                            </div>
                          </div>
                      }
                    </div>
                  </li>
                )
              })
            }
            {
              <li className='w100 h50' />
            }
          </ul>
        </OrderTabsBottomFirst>
        {/* 第2级第二个的选项卡 */}
        <OrderTabsBottomSecond className={'h100 flex' + (tabActive === 1 ? '' : ' clip')}>
          {/* 第2.1级tabs的左侧内容(小锅菜菜谱分类) */}
          <div className='h100 w20 rel'>
            <ul className='abs trbl0 rows bgf6 g0 fs12-4' style={{ bottom: `${OrderShoppingHeight}px` }}>
              {/* <li
                key={'checkAllXgFood'}
                className={'tc vc h11 rel' + (xgActive === 'all' ? ' bgf w99 act' : '')}
                style={{ maxHeight: '45px' }}
                onClick={() => setXgActive('all')}
              >
                <div className='h100 rel'>
                  <div className='abs markNum fs10 gf h12r w14r' style={{ visibility: Number(OrderMark.allXgFoodMark) > 0 ? 'visible' : 'hidden' }}>
                    <div className='w14r tc ml-2'>
                      <div style={{ transform: 'scale(0.75)' }}>{OrderMark.allXgFoodMark}</div>
                    </div>
                  </div>
                </div>
                <div className='no-wrap tl ml10 mr5 lt1'>{intl.get('All')}</div>
              </li> */}
              {/* {
              OrderMark.xgFoodType.length>0?setXgActive(OrderMark.xgFoodType[OrderMark.xgFoodType.length-1].id):''} */}
                {
                OrderMark.xgFoodType.map(xgItems => {
                  if (xgFoodShowArr[`xgTypeShow${xgItems.id}`]) {
                    return (
                      <li
                        key={xgItems.id}
                        className={'tc vc h11 lh1-3 rel' + (xgActive === xgItems.id ? ' bgf w99 act' : '')}
                        style={{ maxHeight: '45px' }}
                        onClick={() => setXgActive(xgItems.id)}
                      >
                        <div className='h100 rel'>
                          <div className='abs markNum fs10 gf h12r w14r' style={{ visibility: xgFoodTypeMarkObj[`xgTypeMark${xgItems.id}`] > 0 ? 'visible' : 'hidden' }}>
                            <div className='w14r tc ml-2'>
                              <div style={{ transform: 'scale(0.75)' }}>{xgFoodTypeMarkObj[`xgTypeMark${xgItems.id}`]}</div>
                            </div>
                          </div>
                        </div>
                        <div className={'tl lt1 ml10 mr5' + (xgActive === xgItems.id ? '' : ' no-wrap')}>{xgItems.typeName}</div>
                      </li>
                    )
                  }
                })
              }
              <li
                key={'checkAllXgFood'}
                className={'tc vc h11 rel' + (xgActive === 'all' ? ' bgf w99 act' : '')}
                style={{ maxHeight: '45px' }}
                onClick={() => setXgActive('all')}
              >
                <div className='h100 rel'>
                  <div className='abs markNum fs10 gf h12r w14r' style={{ visibility: Number(OrderMark.allXgFoodMark) > 0 ? 'visible' : 'hidden' }}>
                    <div className='w14r tc ml-2'>
                      <div style={{ transform: 'scale(0.75)' }}>{OrderMark.allXgFoodMark}</div>
                    </div>
                  </div>
                </div>
                <div className='no-wrap tl ml10 mr5 lt1'>{intl.get('All')}</div>
              </li>
            </ul>
          </div>
          {/* 第2.2级tabs的右侧内容(小锅菜菜谱展示) */}
          <ul className={'h100 w80 rel flex-top pl9 pr9 pt3 ova'} style={showLogo ? { backgroundImage: `url(${sdxBg})`, backgroundSize: '120% 170%' } : { background: '#fff' }}>
            {
              flag.includes('getAllXgFood') && <li className='abs trbl0'>
                <img className='w62 h35 abs auto l0 r0' style={{ top: '13%' }} src={require('../../images/noOrderImg.jpg')} />
                <div className='abs h21r w100' style={{ bottom: '44%' }}>
                  <div className='tc auto w80 g7c fs13 lt1' style={{ height: '1.5rem' }}>
                    {
                      flag === 'getAllXgFood_noFood' && intl.get("There is no chef's special for this meal")
                    }
                  </div>
                </div>
              </li>
            }
            {
              showXgFoodlist.length > 0 && showXgFoodlist.map(itemData => {
                // console.log(itemData)
                return (
                  <li key={itemData.checkId} className='w48 h27 rds8 ovh mb15 foodListBox bgf' style={{ maxHeight: '114px', minHeight: '100px' }}>
                    <div className='h67 ovh rel' onClick={() => { setIsShowAdvice(true); setItemDataCopy(itemData) }}>
                      {
                        itemData.picAddress && itemData.picAddress.indexOf('sodexo') >= 0
                          ? <img className='w100 h100' alt={intl.get('No pictures')} src={itemData.picAddress} />
                          : <div className='h100 bgf1 vc'>
                            <div className={'tc w100 fs23 ga5' + (Language.locale === 'en' ? '' : ' lt1-5')}>{intl.get('No pictures')}</div>
                          </div>
                      }
                    </div>
                    <div className='h33 pl5 pt2 pr5 fs12 rel'>
                      <div className='h50 rel fs11-5 no-wrap'>{itemData.food ? itemData.food.foodName : ''}</div>
                      <div className='h50 b rel priceColor'>
                        <div className='abs b5 fs11-5'>&yen;{itemData.food.unitPrice===0 ? ' --': ' '+ itemData.food.unitPrice }</div>
                      </div>
                      {// 小锅菜已经达到最大份数，则显示已售罄
                        foodTestForMax(itemData)
                          ? <div>
                            <div className='abs w40 tr fs10 g6 r30 b5'>{intl.get('Sold out')}</div>
                            <div className={'abs r5 b2'}
                              style={{ bottom: '-0.06rem' }}
                              onClick={() => {
                                foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, props.chooseDate, OrderMark)
                              }}>
                              <Add />
                            </div>
                          </div>
                          : <div>
                            <div
                              className={'abs b2' + (itemData.selectedQuantity <= 0 ? ' disabled' : '')}
                              style={{ right: '3rem', bottom: '-0.06rem' }}
                              onClick={() => {
                                foodDecrease(itemData, OrderInfo)
                              }}>
                              {
                                itemData.selectedQuantity === 0 ? <Decrease /> : <Decrease circleBg={'#f31c69'} />
                              }
                            </div>
                            <div className='abs r20 b5 tc w21r fs11-5' style={{ bottom: '0.3rem' }}>{itemData.selectedQuantity ? itemData.selectedQuantity : 0 }</div>
                            <div
                              className={'abs r5 b2'}
                              style={{ bottom: '-0.06rem' }}
                              onClick={() => {
                                foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, props.chooseDate, OrderMark)
                              }}>
                              {
                                addFoodTestForMax(itemData, OrderInfo, props.chooseDate) ? <Add /> : <Add circleBg={'#f31c69'} />
                              }
                            </div>
                          </div>
                      }
                    </div>
                  </li>
                )
              })
            }
            {
              <li className='w100 h50' />
            }
          </ul>
        </OrderTabsBottomSecond>
      </OrderTabsBottom>
      <div className={'fixed trbl0 trans zx20'} style={{ transform: isShowAdvice ? 'translateY(0%)' : 'translateY(100%)' }} >
        <OrderContentDetails setIsShowAdvice={setIsShowAdvice} itemDataCopy={itemDataCopy} setShowModal={setShowModal} setModalInfo={setModalInfo} setModalTitle={setModalTitle} setModalOkButton={setModalOkButton} setShowMenuModal={setShowMenuModal} chooseDate={props.chooseDate} />
      </div>
      <MyModal
        visible={showModal}
        info={modalInfo}
        title={modalTitle}
        cancelButtonVisible={showCancel}
        wapperStyle={{ width: '72%', height: '27%' }}
        okButton={modalOkButton}
        onOkClick={() => {
          setShowModal(false)
          if (flag === 'XXXSPEXXX') {
            foodIncrease(showYyFoodlist[0], OrderInfo, setShowModal, setModalInfo, props.chooseDate, OrderMark)
            setShowCancel(false)
          }
          if (flag === 'tabCheck') {
            setTabActive(1)
          }
          setFlag('')
        }}
        onCancelClick={() => {
          setShowCancel(false)
          setShowModal(false)
        }}
      />
      <MyMenuModal
        visible={showMenuModal}
        info={modalInfo}
        title={modalTitle}
        cancelButtonVisible={showCancel}
        wapperStyle={{ width: '72%', height: '35%' }}
        okButton={modalOkButton}
        onOkClick={() => {
          setShowModal(false)
          setShowMenuModal(false)
        }}
        onCancelClick={() => {
          setShowCancel(false)
          setShowModal(false)
          setShowMenuModal(false)
        }}
      />
    </OrderMiddle>
  )
}
